import { Flex } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import './CustomInputGroup.scss';

interface CustomInputGroupProps {
  children: ReactNode;
}

const CustomInputGroup = ({ children }: CustomInputGroupProps) => {
  return <Flex className={'custom-input-group'}>{children}</Flex>;
};

export default CustomInputGroup;
